export const defaultLocale = 'ja'
export const locales = ['ja']
